var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8772 0.135266C11.7118 -0.0450886 11.4431 -0.0450886 11.2777 0.135266L6.0058 5.89533L0.72359 0.135266C0.558198 -0.0450886 0.289436 -0.0450886 0.124044 0.135266C-0.041348 0.31562 -0.041348 0.608696 0.124044 0.78905L5.69569 6.86473C5.77839 6.95491 5.88176 7 5.99546 7C6.09883 7 6.21254 6.95491 6.29524 6.86473L11.8669 0.78905C12.0426 0.608696 12.0426 0.31562 11.8772 0.135266V0.135266Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqArrowIcon);
export default __webpack_public_path__ + "static/media/FaqArrowIcon.9ff8816812606fb38c1cc07d74ca1f3b.svg";
export { ForwardRef as ReactComponent };